import './App.css';
import Routes from './Routes/index'
import React, { useEffect } from 'react'
import axios from 'axios'
function App() {
  useEffect(()=>{
    apiCall()
  },[])
  async function  apiCall(){
    try{
      const response = await axios.get('https://odds-directly-got-band.trycloudflare.com/test-api')
      console.log("data", response.data);
    }catch(errr){
      console.log('err',errr);
      
    }

  }
  return (
        <>
          <Routes />
        </>
  );
}

export default App;